import React, { useEffect } from 'react'
import ProjectListComponents from '../../components/ProjectList/projectList.components'
import { getCookie } from 'helper/cookie'
import { useHistory } from 'react-router-dom'
import { getPermissionControl } from 'api/Admin/rolePermission'
import _refiner from 'refiner-js'
import { REACT_APP_REFINER_FORM_ID, PROJECT_LIST_V2 } from '../../config/env'
import ProjectListV2Page from '../ProjectListV2/index'

const HomePage = () => {
  const history = useHistory()

  // Refiner Survey on project list page
  useEffect(() => {
    _refiner('showForm', REACT_APP_REFINER_FORM_ID)
  }, [])

  //check permission
  const roleUser = getCookie('roleUser')
  const token = getCookie('access_token_admin')
  const getPermission = async () => {
    let checkRead = false
    await getPermissionControl({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (status === 200) {
          data.result?.permission?.map((item) => {
            if (item.menu_id == 2) {
              checkRead = true
            }
            if (item.menu_id == 3) {
              checkRead = true
            }
            if (item.menu_id == 25) {
              checkRead = true
            }
          })
          checkRead ? _ : history.push(`/no-permission`)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      getPermission()
    }
  }, [token])
  /*
   * The switch lives here, not in `App.js`: this component owns the permission gate above
   * (menu_id 2/3/25 -> `/no-permission`) and the Refiner survey, and `ProjectListV2Page` has
   * neither. Routing straight to it would serve the page without checking the permission.
   */
  return <>{PROJECT_LIST_V2 ? <ProjectListV2Page /> : <ProjectListComponents />}</>
}

export default HomePage
